import { ROUTES } from '@constants'

import { RouteStrategy, RouteStrategyParams } from './routeStrategy'

export class SearchAssistantRoute implements RouteStrategy {
  public getRedirectPath(params: RouteStrategyParams): string | undefined {
    const { searchAssistantId } = params

    if (!searchAssistantId) {
      console.warn('SearchAssistant ID is required to redirect to config')

      return undefined
    }

    return ROUTES.CONFIG_SEARCH_ASSISTANTS_EDIT_ID.replace(':id', searchAssistantId.toString())
  }
}
